import { render } from "./recommand.vue?vue&type=template&id=2e365214&scoped=true"
import script from "./recommand.vue?vue&type=script&lang=js"
export * from "./recommand.vue?vue&type=script&lang=js"

import "./recommand.vue?vue&type=style&index=0&id=2e365214&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e365214"]])

export default __exports__